import React from "react";
import { OperatingSystems } from "../../utils/vendor";
import SaveHyperOnIos from "./SaveHyperOnIos/SaveHyperOnIos";
import {
  GenericModalProps,
  ThemeVariant,
} from "../../utils/constants/generic-types";
import SaveHyperOnAndroid from "./SaveHyperOnAndroid/SaveHyperOnAndroid";
import { checkOs } from "../../utils/helpers";

interface PwaInstallationDialogProps extends GenericModalProps {
  saveHyperDialogTheme?: ThemeVariant;
}

export default function PwaInstallationDialog({
  isOpen,
  onClose,
  saveHyperDialogTheme,
}: PwaInstallationDialogProps) {
  if (checkOs() === OperatingSystems.Ios) {
    return (
      <SaveHyperOnIos
        isOpen={isOpen}
        onClose={onClose}
        theme={saveHyperDialogTheme}
      />
    );
  }
  return (
    <SaveHyperOnAndroid
      isOpen={isOpen}
      onClose={onClose}
      theme={saveHyperDialogTheme}
    />
  );
}
